import React from "react";
import {Image, Spin} from "antd"
import "./FileAttachment.scss";
import { appAssetsConfig } from "../../../constants/config/appAssetsConfig";

const FileAttachment = ({
  attachmentObj,
  loading,
  attachmentUrl
}) => {
  return (
    <>
      <div className="file-attachment-main-container">
        <div className="file-attachment-container">
          {
            loading ?
            <Spin/>
            :
            <Image
              preview={!attachmentUrl ? false : true}
              className="file-attachment"
              src={
                attachmentUrl && attachmentUrl!=="" && attachmentUrl !== null && attachmentUrl!==undefined ?
                attachmentUrl :
                attachmentObj &&
                attachmentObj !== undefined &&
                attachmentObj !== null
                  ? URL.createObjectURL(attachmentObj)
                  : appAssetsConfig.DEFAULT_PROFILE_IMAGE 
              }
            />
          }
        </div>
      </div>
    </>
  );
};

export default FileAttachment;
